<i18n>
{
  "fr": {
    "dashboard-title": "Dashboard - Datalake",
    "contact-list-title": "Gestion des contacts",
    "contact-list-show": "Voir la liste",
    "contact-list-desc": "C'est ici que vous pouvez gérer les contacts disponibles dans le formulaire.",
    "form-list-collect-gw-title": "Gestion des formulaires <b>Collect GW</b>",
    "form-list-collect-gw-desc": "C'est ici que vous pouvez gérer les formulaires d'annonce pour le téléversement de données sur les eaux souterraines.",
    "form-collect-gw-create": "Créer une nouvelle entrée",
    "form-list-collect-gw-show": "Voir la liste",
    "project-list-title": "Gestion des projets",
    "project-list-desc": "C'est ici que vous pouvez gérer les projets disponibles dans le formulaire.",
    "project-list-show": "Voir la liste",
    "regis-analyses-extractor-title": "Extraction d'analyses",
    "regis-analyses-extractor-desc": "Extraction de paramètres mesurés se trouvant sur la base de donnée REGIS.",
    "goto-label": "Accès",
    "regis-parameters-catalog-title": "Catalogue de paramètres chimiques",
    "regis-parameters-catalog-desc": "Accès au catalogue de paramètres chimiques disponible sur la base de donnée REGIS.",
    "regis-suggested-parameters-title": "Proposition d'ajout au catalogue",
    "regis-suggested-parameters-desc": "Liste des propositions d'ajout du catalogue de paramètres chimiques disponible sur la base de donnée REGIS."
  },
  "de": {
    "dashboard-title": "Dashboard - Datalake",
    "contact-list-title": "Kontaktverwaltung",
    "contact-list-show": "Konsultieren",
    "contact-list-desc": "Hier können Sie die im Formular verfügbaren Kontakte verwalten.",
    "form-list-collect-gw-title": "Formularverwaltung <b>Collect GW</b>",
    "form-list-collect-gw-desc": "Hier können Sie die Meldeformular zum Datenupload von Grundwasserdaten verwalten",
    "form-collect-gw-create": "Neuen Eintrag erstellen",
    "form-list-collect-gw-show": "Konsultieren",
    "project-list-title": "Projektsverwaltung",
    "project-list-desc": "Hier können Sie die im Formular verfügbaren Projekte verwalten.",
    "project-list-show": "Konsultieren"
  }
}
</i18n>

<template>
  <div id="dashboard">

    <Header :title="$t('dashboard-title')" />

    <md-content class="md-elevation-3 main-container">

      <div class="dashboard-options">

        <md-card md-with-hover v-if="accessToken.hasRight('datalake_alterForm')">
          <md-ripple>
            <md-card-header>
              <div class="md-title" v-html="$t('form-list-collect-gw-title')"></div>
            </md-card-header>

            <md-card-content>
              {{ $t('form-list-collect-gw-desc') }}
            </md-card-content>

            <md-card-actions>
              <md-button @click="$router.push({ name: 'new-form-collect-data-gw' })">{{ $t('form-collect-gw-create') }}</md-button>
              <md-button @click="$router.push({ name: 'list-form' })">{{ $t('form-list-collect-gw-show') }}</md-button>
            </md-card-actions>
          </md-ripple>
        </md-card>

        <!-- <md-card md-with-hover v-if="accessToken.hasRight('datalake_alterCommonData')">
          <md-ripple>
            <md-card-header>
              <div class="md-title">{{ $t('contact-list-title') }}</div>
            </md-card-header>

            <md-card-content>
              {{ $t('contact-list-desc') }}
            </md-card-content>

            <md-card-actions>
              <md-button @click="$router.push({ name: 'list-contact' })">{{ $t('contact-list-show') }}</md-button>
            </md-card-actions>
          </md-ripple>
        </md-card> -->

        <md-card md-with-hover v-if="accessToken.hasRight('datalake_alter_common_data')">
          <md-ripple>
            <md-card-header>
              <div class="md-title" v-html="$t('project-list-title')"></div>
            </md-card-header>

            <md-card-content>
              {{ $t('project-list-desc') }}
            </md-card-content>

            <md-card-actions>
              <md-button @click="$router.push({ name: 'list-project' })">{{ $t('project-list-show') }}</md-button>
            </md-card-actions>
          </md-ripple>
        </md-card>

      </div>

    </md-content>

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import AccessToken from '@/helpers/access-token'

import Header from '@/components/header'
import Snackbar from '@/components/snackbar'

export default {
  name: 'Dashboard',
  components: {
    Header,
    Snackbar
  },
  data () {
    return {
      accessToken: AccessToken.get()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadData().then(() => {

      }).catch(this.handleError)
    })
  },
  methods: {
    loadData () {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style lang="scss">
  .dashboard-options {
    display: flex;
    justify-content: space-around;
    padding: 35px;
    flex-wrap: wrap;
    align-content: space-between;
    align-items: center;

    .md-card {
      width: 370px;
      min-width: 370px;
      max-width: 370px;
      margin-bottom: 35px;
      user-select: none;
    }

  }
</style>
